module.exports = __webpack_public_path__ + "static/media/analytics.cf44a4d4.svg";